"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreedLimitButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const setPregnancyLimits_json_1 = __importDefault(require("@framework/abis/json/ExchangeBreedFacet/setPregnancyLimits.json"));
const dialogs_1 = require("../../../../dialogs");
const validation_1 = require("./dialog/validation");
const BreedLimitButton = (props) => {
    const { className, disabled, variant } = props;
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const metaFnWithContract = (0, react_hooks_eth_1.useSystemContract)(async (values, systemContract) => {
        return writeContractAsync({
            address: systemContract.address,
            abi: setPregnancyLimits_json_1.default,
            functionName: "setPregnancyLimits",
            args: [values.count, values.time, values.maxTime],
        });
    });
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)((values) => {
        return metaFnWithContract(types_1.SystemModuleType.EXCHANGE, values);
    });
    const handleBreedLimitConfirmed = async ({ data }) => {
        await metaFn(data);
    };
    const handleBreedLimit = () => {
        openDialog(dialogs_1.GlobalDialogKeys.CONTRACT_MINT, {}, {
            initialValues: {
                count: 0,
                time: 0,
                maxTime: 0,
            },
            validationSchema: validation_1.breedLimitsValidationSchema,
            message: "dialogs.breedLimit",
            testId: "BreedLimitForm",
            onExternalConfirm: handleBreedLimitConfirmed,
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleBreedLimit, icon: icons_material_1.Bloodtype, message: "pages.breed.limit", className: className, dataTestId: "BreedLimitButton", disabled: disabled, variant: variant }));
};
exports.BreedLimitButton = BreedLimitButton;
//# sourceMappingURL=index.js.map